import { render } from "./KonvaSeatEditor.vue?vue&type=template&id=0a354405&scoped=true"
import script from "./KonvaSeatEditor.vue?vue&type=script&lang=js"
export * from "./KonvaSeatEditor.vue?vue&type=script&lang=js"

import "./KonvaSeatEditor.vue?vue&type=style&index=0&id=0a354405&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a354405"]])

export default __exports__